import { ConfluenceTryEndLearnImage, JPDTryEndLearnImage, JSMTryEndLearnImage } from './assets';
import messages from './messages';
import type { AppSwitcherNudgeType } from './types';

export const APP_SWITCHER_NUDGES: Array<AppSwitcherNudgeType> = [
	{
		messageId: 'jsw-end-user-activated-jpd_v2',
		heading: messages.heading,
		content: messages.jpdContent,
		image: JPDTryEndLearnImage,
		primaryActionText: messages.jpdPrimaryButtonText,
		primaryOnClickAction: (host?: string, orgId?: string, cloudId?: string) => {
			window.open(`${host}/o/${orgId}/products/jira-product-discovery/${cloudId}`, '_blank');
		},
	},
	{
		messageId: 'jsw-end-user-activated-jsm_v2',
		heading: messages.heading,
		content: messages.jsmContent,
		image: JSMTryEndLearnImage,
		primaryActionText: messages.confluenceAndJsmPrimaryButtonText,
		primaryOnClickAction: () =>
			window.open('/secure/WelcomeToSD.jspa?decorator=jsd-onboarding', '_blank'),
	},
	{
		messageId: 'jsw-end-user-activated-confluence_v2',
		heading: messages.heading,
		content: messages.confluenceContent,
		image: ConfluenceTryEndLearnImage,
		primaryActionText: messages.confluenceAndJsmPrimaryButtonText,
		primaryOnClickAction: () => window.open('/wiki/welcome', '_blank'),
	},
];
